import { network } from 'services/network';

import { QueryParams } from 'api/queries/getMappedContracts.query';

export const getMappedContracts = (params: QueryParams) => {
    const url = 'api/bo/phaseperformance/getMappedContracts';
    return network.post(url, { template_id: params.templateId, filter: params.filter }).then((response) => {
        return response.data;
    });
};
